// convert long number into abbreviated string
export default function formatNumberToAbbString(num) {
return  Intl.NumberFormat('en-US', {
    notation: "compact",
    maximumFractionDigits: 0
  }).format(num);
}
